import { render, staticRenderFns } from "./PartnerTransferCheck.vue?vue&type=template&id=20f37da6&scoped=true&"
import script from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"
export * from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f37da6",
  null
  
)

export default component.exports